var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.001,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3b5175}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19 2.9a1.15 1.15 0 0 1-.3.8.85.85 0 0 1-.7.3h-6a1 1 0 0 1-1-1V2H8v1a1 1 0 0 1-1 1H1.05A1.05 1.05 0 0 1 0 3.1a1.15 1.15 0 0 1 .3-.8A.85.85 0 0 1 1 2h5V1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1h4.95a1.05 1.05 0 0 1 1.05.9ZM14.9 6.9 13.7 19H5.3L4.1 6.9a1 1 0 0 0-1-.9 1 1 0 0 0-1 1.1l1.3 13a1 1 0 0 0 1 .9h10.2a1 1 0 0 0 1-.9l1.3-13a1 1 0 0 0-1-1.1 1 1 0 0 0-1 .9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelIcon);
export default __webpack_public_path__ + "static/media/Del_icon.9bd91a5160b1985037fd329026a5fe72.svg";
export { ForwardRef as ReactComponent };